// App sidebar navigation with KayQ branding - 73 lines ✅
import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, FileText, Database, FolderOpen, Plus, Settings, Network } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

interface SidebarProps {
  isOpen: boolean
  onClose: () => void
}

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/issues', icon: FileText, label: 'Issues' },
  { to: '/knowledge', icon: Database, label: 'Knowledge Base' },
  { to: '/documents', icon: FolderOpen, label: 'Documents' },
  { to: '/architecture', icon: Network, label: 'System Architecture' },
  { to: '/settings', icon: Settings, label: 'Settings' },
]

export function Sidebar({ isOpen, onClose }: SidebarProps): JSX.Element {
  const location = useLocation()

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-kaycoo-charcoal/80 backdrop-blur-sm md:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-50 w-64 transform border-r border-kaycoo-white-3 bg-kaycoo-white transition-transform duration-300 ease-in-out md:relative md:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="flex h-full flex-col">
          <div className="flex-1 space-y-1 p-4">
            <Link to="/issues/new">
              <Button className="w-full justify-start gap-2 bg-kaycoo-teal-dark text-white hover:bg-kaycoo-teal-dark-2" size="lg">
                <Plus className="h-5 w-5" />
                New Issue
              </Button>
            </Link>

            <nav className="space-y-1 pt-4" role="navigation" aria-label="Main navigation">
              {navItems.map((item) => {
                const Icon = item.icon
                const isActive = location.pathname === item.to

                return (
                  <Link key={item.to} to={item.to} onClick={onClose}>
                    <Button
                      variant="ghost"
                      className={cn(
                        'w-full justify-start gap-2 text-kaycoo-charcoal hover:bg-kaycoo-teal-pale hover:text-kaycoo-teal-dark',
                        isActive && 'bg-kaycoo-teal-pale text-kaycoo-teal-dark font-semibold'
                      )}
                    >
                      <Icon className="h-5 w-5" />
                      {item.label}
                    </Button>
                  </Link>
                )
              })}
            </nav>
          </div>
        </div>
      </aside>
    </>
  )
}
